import React, { Component } from 'react'
import {connect} from 'react-redux'

@connect(state => ({alerts: state.ui.alerts}))
export default class Alerts extends Component {
  static defaultProps = {
    timeout: 4000,
    autoMiss: true
  }

  state = {
    hidden: false,
    ttd: null
  }

  dismiss () {
    this.setState({hidden: true})
    // this.props.onDismiss()
    this.resetTimeout()
  }

  onClick = e => {
    this.dismiss()
    const item = this.state.buttons.filter((button) => {
      return button.name.toLowerCase() === e.target.id
    }).shift()
    item && item.listener && item.listener(e)
  }

  resetTimeout () {
    if (this.state.ttd) {
      clearTimeout(this.state.ttd)
      this.setState({ttd: null})
    }
  }

  componentWillReceiveProps (props) {
    if (!props.alerts) return
    const alert = props.alerts.pop()
    if (!alert) return

    const autoMiss = alert.autoMiss ? (!alert.buttons) : this.props.autoMiss
    let nextState = {...alert}

    if (autoMiss && !alert.hidden) {
      const ttd = setTimeout(this.dismiss.bind(this), alert.timeout || this.props.timeout)
      nextState.ttd = ttd
    }

    this.setState(nextState)
  }

  componentWillMount () {
    this.componentWillReceiveProps(this.props)
  }

  componentWillUnmount () {
    this.resetTimeout()
  }

  renderButtons () {
    const {buttons} = this.state

    return <div className='buttons'>
      {buttons.map((button, i) => {
        const id = button.name.toLowerCase()
        return <button key={i} id={id} className={id} onClick={this.onClick}>{button.name}</button>
      })}
    </div>
  }

  render () {
    const {type, message, buttons, hidden} = this.state

    return <div className='crouton' hidden={hidden}>
      <div className={type}>
        <span>{message}</span>
        {buttons ? this.renderButtons() : null}
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/ui/Alerts.js